import { objectTypes } from '../constants/types';
import { fetchPlaybooks, fetchRecommendedPlaybooks } from '../data/api/playbooksApi';
import { routes } from './routes';
export const defaultPlaybooksProps = {
  selectedObjectType: objectTypes.contacts,
  selectedObjectId: '',
  portalId: 0,
  apiWrapper: {
    fetchPlaybooks,
    fetchRecommendedPlaybooks
  },
  openUrl: url => {
    window.open(url, '_blank');
  },
  usageTracker: {
    trackInteraction: () => undefined,
    trackPageView: () => undefined,
    trackUsage: () => undefined
  },
  callObjectId: 0,
  featureTipsLink: '',
  reconnectRoute: routes.reconnect
};